import { Transition } from "@headlessui/react";
import { Fragment, useMemo } from "react";

import { useAppSelector } from "@/hooks/redux-hooks";

export const RestrictionBackDrop = () => {
  const { isOpen: isSubscribeOpen } = useAppSelector(
    (state) => state.subscribeDialog
  );
  const { isOpen: isLoginOpen } = useAppSelector((state) => state.loginDialog);

  const observer = useMemo(() => {
    if (typeof window === "undefined") return;
    return new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        // if the backdrop is removed, scroll to top
        if (mutation.removedNodes) {
          mutation.removedNodes.forEach((node) => {
            if ((node as HTMLDivElement).id === "sacred-backdrop")
              window.scrollTo(0, 0);
          });
        }

        // if the backdrop's style or class is changed, scroll to top
        if (
          mutation.type === "attributes" &&
          mutation.target instanceof HTMLDivElement &&
          mutation.target.id === "sacred-backdrop"
        )
          window.scrollTo(0, 0);
      });
    });
  }, []);

  let timer: NodeJS.Timeout;

  return (
    <Transition
      show={isSubscribeOpen || isLoginOpen}
      as={Fragment}
      beforeLeave={() => {
        clearTimeout(timer);
        observer?.disconnect();
      }}
      afterEnter={() => {
        clearTimeout(timer);
        // this is a hack to prevent headlessui from adding overflow:hidden, padding-right:16px to the body
        document.documentElement.style.overflow = "unset";
        document.documentElement.style.paddingRight = "unset";
        timer = setTimeout(() => {
          observer?.observe(document.body, {
            childList: true,
            subtree: true,
            attributes: true,
            attributeFilter: ["style", "class"],
          });
        }, 2000);
      }}
    >
      <div
        id="sacred-backdrop"
        className="fixed inset-0 z-[99997] bg-gray-500 bg-opacity-75 backdrop-blur-sm transition-opacity"
      />
    </Transition>
  );
};
